__turbopack_context__.v({
  "banner": "IIYnJW_banner",
  "body": "IIYnJW_body",
  "content": "IIYnJW_content",
  "illustration": "IIYnJW_illustration",
  "signupLink": "IIYnJW_signupLink",
  "text": "IIYnJW_text",
  "title": "IIYnJW_title",
});
